import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import './MyOrdersPage.css';
import ReactLoading from 'react-loading';
import axios from 'axios';
import { UserContext } from '../../context/UserProvider';
import Navbar from "../../components/navbars/Navbar";
import { useUser } from "../../context/UserProvider";
import { fetchAuthSession } from "aws-amplify/auth";
import RequestCallbackButton from "../../components/callbackbutton/RequestCallbackButton";


export default function MyOrdersPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { mongoUser, cognitoUser } = useUser();
    // STATE ***********************************
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [noOrders, setNoOrders] = useState('');
    const [expand, setExpand] = useState({});
    const [uploadedImages, setUploadedImages] = useState({});
    const [msg, setMsg] = useState('');
    const [uploadedStatus, setUploadedStatus] = useState({});
    const [albumFiles, setAlbumFiles] = useState({});
    const [productFiles, setProductFiles] = useState({});
    const [recentOrderId, setRecentOrderId] = useState(null);
    const [imagesCompleted, setImagesCompleted] = useState(false);
    const [isReadyForEditing, setIsReadyForEditing] = useState({});
    const [loadingImages, setLoadingImages] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [pictureLoading, setPictureLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [uploadingImages, setUploadingImages] = useState({})
    const [selectedImageIndex, setSelectedImageIndex] = useState(null)
    // FUNCTIONS **************** FUNCTIONS ************* FUNCTIONS ********************
    const toggleExpand = (orderId) => {
        setExpand((prevState) => ({
            ...prevState,
            [orderId]: !prevState[orderId],
        }));
    };

    // ✅ Trigger file input for products
const triggerProductInput = (productId) => {
    document.getElementById(`productFileInput-${productId}`).click();
};


    // Trigger file input for albums
const triggerAlbumInput = (albumId) => {
    document.getElementById(`albumFileInput-${albumId}`).click();
};

    // Helper function to check if all images have been uploaded for both albums and products
    const checkIfAllImagesUploaded = (order) => {
        const allAlbumsUploaded = order.albums.every(album => uploadedStatus[album._id]);
        const allProductsUploaded = order.products.every(product => uploadedStatus[product._id]);
        return allAlbumsUploaded && allProductsUploaded;
    };

    const openImageModal = async (orderId, item, type, index) => {
        try {
            setPictureLoading(true);
            
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            const mongoUserID = mongoUser._id;
            
            if (!idToken) {
                console.error("❌ Missing Auth Token. User is not authenticated.");
                alert("Authentication error. Please log in again.");
                return;
            }
            
            console.log("🔹 ID Token:", idToken);
            
            let apiUrl = `${import.meta.env.VITE_GALLERY_API}/galleries/user/${mongoUserID}/${orderId}/items`;
            setIsLoading(true)
            // ✅ Include necessary details in the request params (not body)
            const requestParams = { 
                mongoUserId: mongoUserID,  // ✅ Include user ID
                orderId,                   // ✅ Include order ID
                type
            };
            
            if (type === "album") {
                requestParams.albumName = item.albumName;
                requestParams.albumSize = item.albumOptions.size;
                requestParams.albumPages = item.albumOptions.pages;
                requestParams.albumIndex = index;
            } else if (type === "product") {
                console.log("🛠️ Debug - Checking Product Data:", item);
                requestParams.productName = item.productName;
                requestParams.productSize = item.productOptions?.size;
                requestParams.productIndex = index;
            }
    
            const response = await axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                },
                params: requestParams // ✅ Correct usage
            });
    
            console.log("API Response:", response.data);
            if (!response.data.images || response.data.images.length === 0) {
                alert("No images found for this item.");
                return;
            }
    
            if (response.status === 200) {
                const images = response.data.images.map(img => img.url);
                setSelectedImages(images);
                setSelectedItem({ orderId, type }); // ✅ Removed `itemId`
                setIsModalOpen(true);
            } else {
                alert("No images found for this item.");
            }
        } catch (err) {
            console.error("Error fetching images:", err.response?.data || err.message);
            alert(`Failed to load images: ${err.response?.data?.message || err.message || "Unknown error"}`);
        }
         finally {
            setPictureLoading(false);
            setIsLoading(false)
        }
    };
    
    
    const handleDeleteImage = async (orderId, albumId, productId, fileName, albumName, albumSize, albumPages, albumIndex, productName, productSize, productIndex) => {
        try {
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            const mongoUserID = mongoUser._id;
    
            if (!idToken) {
                console.error("❌ Missing Auth Token.");
                return;
            }
    
            console.log(`🗑️ Deleting image: ${fileName}`);
    
            // ✅ Send DELETE request
            await axios.delete(
                `${import.meta.env.VITE_GALLERY_API}/galleries/user/delete-image`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${idToken}`,
                    },
                    data: {
                        mongoUserID,
                        orderId,
                        fileName,
                        ...(albumId
                            ? { albumId, albumName, albumSize, albumPages, albumIndex }
                            : { productId, productName, productSize, productIndex }),
                    },
                }
            );
    
            console.log("✅ Image deleted successfully.");
    
            // ✅ Remove image from selectedImages state
            setSelectedImages(prevImages => prevImages.filter(img => img !== fileName));
    
            // ✅ Fetch updated image counts
            const imageCounts = await fetchImageCounts();
    
            // ✅ Update the image count in state
            setData(prevOrders =>
                prevOrders.map(order => {
                    if (order._id !== orderId) return order;
    
                    return {
                        ...order,
                        albums: order.albums.map((album, idx) => {
                            const key = `${album.albumName}${album.albumOptions.size}-${album.albumOptions.pages}-${idx}`;
                            return {
                                ...album,
                                imageCount: imageCounts?.[order._id]?.albums?.[key] ?? 0,
                            };
                        }),
                        products: order.products.map((product, idx) => {
                            const key = `${product.productName}-${product.productOptions.size}-${idx}`;
                            return {
                                ...product,
                                imageCount: imageCounts?.[order._id]?.products?.[key] ?? 0,
                            };
                        }),
                    };
                })
            );
    
        } catch (error) {
            console.error("❌ Error deleting image:", error);
            alert("Failed to delete image. Please try again.");
        }
    };
    

    // Function to send status update to backend
    const updateOrderStatus = async (orderId, orderIndex) => {
        try {
            const order = data.find((order) => order._id === orderId);
            if (!order) {
                console.error(`Order ${orderId} not found in state.`);
                return;
            }
    
            const hasAlbum = order?.albums && Array.isArray(order.albums) && order.albums.length > 0;
            const hasEditingProduct = order?.products && Array.isArray(order.products) && order.products.some(product => product.productName === 'Editing');
    
            let status;
            if (hasAlbum || hasEditingProduct) {
                status = 'Sent to editing team';
            } else {
                status = 'Send to manufacturing';
            }
    
            setIsLoading(true);
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
    
            await axios.put(
                `${import.meta.env.VITE_ORDERS_API}/orders/${mongoUser._id}/${orderId}/status-update`,
                {
                    status: status,
                    readyForEditing: hasAlbum || hasEditingProduct,
                    firstName: mongoUser.firstName,
                    lastName: mongoUser.lastName,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${idToken}`,
                    },
                }
            );
    
            console.log(`✅ Order ${orderId} status updated to "${status}" successfully.`);
        } catch (error) {
            console.error('❌ Error updating order status:', error);
        } finally {
            setIsLoading(false);
        }
    };
    
   

    // Handle file selection and upload for albums
    const handleAlbumFileChange = async ( orderId, albumId, albumName, albumSize, albumPages, albumIndex, e) => {
         // ✅ Ensure orderId is correctly fetched
        if (!orderId) {
            console.error("❌ Error: Missing orderId. Cannot upload images.");
            return;
        }
    
        const files = Array.from(e.target.files);
        const maxImagesAllowed = 2 * albumPages;

         // 🧠 Find the imageCount from `data` state
        const currentCount = data.find(order => order._id === orderId)
        ?.albums?.[albumIndex]?.imageCount || 0;

        if (currentCount + files.length > maxImagesAllowed) {
            alert(
              `You've already uploaded ${currentCount} images. You can only upload ${
                maxImagesAllowed - currentCount
              } more.`
            );
            return;
          }
    
        if ((albumFiles[orderId]?.[albumId] || 0) + files.length > maxImagesAllowed) {
            alert(`You can upload up to ${maxImagesAllowed} images for this album.`);
            return;
        }
    
        setMsg('Generating upload URLs...');
    
        try {
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            
            // ✅ Use correct `orderId`
            const { data: { signedUrls } } = await axios.post(
                `${import.meta.env.VITE_GALLERY_API}/galleries/user/${mongoUser._id}/${orderId}`, 
                {
                    mongoUserId: mongoUser._id,
                    orderId,
                    albumId,
                    albumName,
                    albumIndex,
                    albumSize,
                    albumPages,
                    images: files.map((file) => ({
                        fileName: file.name,
                        mimeType: file.type,
                    })),
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${idToken}`,
                    }
                }
            );
    
            setMsg('Generating upload urls...');
            setUploadingImages((prev) => ({
                ...prev,
                [orderId]: {
                    ...(prev[orderId] || {}),
                    [albumId]: true, // ✅ Only the specific album's button shows the spinner
                }
            }));
            
    
            // Step 2: Upload each file directly to S3
            
            const uploadPromises = signedUrls.map(async ({ fileName, uploadUrl }) => {
                const file = files.find((f) => f.name === fileName);
                await fetch(uploadUrl, {
                    method: "PUT",
                    body: file,
                    headers: { "Content-Type": file.type }
                });
                return fileName;
            });
    
            await Promise.all(uploadPromises);
            setMsg('Upload successful');

            // ✅ Refetch image counts after upload
            const imageCounts = await fetchImageCounts();
            setData(prevOrders =>
                prevOrders.map(order => {
                    if (order._id !== orderId) return order;
            
                    return {
                        ...order,
                        albums: order.albums.map((album, idx) => {
                            const key = `${album.albumName}${album.albumOptions.size}-${album.albumOptions.pages}-${idx}`;
                            return {
                                ...album,
                                imageCount: imageCounts?.[order._id]?.albums?.[key] ?? 0
                            };
                        }),
                        products: order.products // unchanged
                    };
                })
            );
    
            // Step 3: Update order-specific state
            setUploadedImages((prev) => ({
                ...prev,
                [orderId]: {
                    ...prev[orderId],
                    [albumId]: URL.createObjectURL(files[0]),
                },
            }));
    
            setUploadedStatus((prevStatus) => ({
                ...prevStatus,
                [orderId]: {
                    ...prevStatus[orderId],
                    [albumId]: true,
                },
            }));
    
            setAlbumFiles((prev) => ({
                ...prev,
                [orderId]: {
                    ...prev[orderId],
                    [albumId]: (prev[orderId]?.[albumId] || 0) + files.length,
                },
            }));
    
            if (checkIfAllImagesUploaded(data[albumIndex])) {
                updateOrderStatus(orderId, albumIndex);
            }
        } catch (error) {
            console.error('Error uploading album files:', error);
            setMsg('Upload failed');
        } finally {
            // ✅ Stop the loading spinner when all images in the order are done
            setUploadingImages((prev) => ({
                ...prev,
                [orderId]: {
                    ...(prev[orderId] || {}),
                    [albumId]: false, // ✅ Reset only for this album
                }
            }));
        }
    };
    
    
    

    // Handle file selection and upload for products
    const handleProductFileChange = async (orderId, productId, productName, productSize, productIndex, e) => {
         // ✅ Ensure orderId is correctly fetched
        if (!orderId) {
            console.error("❌ Error: Missing orderId. Cannot upload images.");
            return;
        }
    
        const files = Array.from(e.target.files);
        const maxImagesAllowed = 1;
      
        // 🧠 Find the current image count from `data` state
        const currentCount = data.find(order => order._id === orderId)
          ?.products?.[productIndex]?.imageCount || 0;
      
        if (currentCount >= maxImagesAllowed) {
          alert("You've already uploaded the maximum number of images for this product.");
          return;
        }
      
        if (files.length > maxImagesAllowed - currentCount) {
          alert(
            `Only ${
              maxImagesAllowed - currentCount
            } image${maxImagesAllowed - currentCount === 1 ? "" : "s"} can be added.`
          );
          return;
        }
    
        setMsg('Generating upload URL...');
    
        try {
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            
            // ✅ Use correct `orderId`
            const { data: { signedUrls } } = await axios.post(
                `${import.meta.env.VITE_GALLERY_API}/galleries/user/${mongoUser._id}/${orderId}`, 
                {
                    mongoUserId: mongoUser._id,
                    orderId,
                    productId,
                    productName,
                    productSize,
                    productIndex,
                    images: files.map((file) => ({
                        fileName: file.name,
                        mimeType: file.type,
                    })),
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${idToken}`,
                    }
                }
            );
    
            setMsg('Uploading file...');
            setUploadingImages((prev) => ({
                ...prev,
                [orderId]: {
                    ...(prev[orderId] || {}),
                    [productId]: true, // ✅ Only the specific album's button shows the spinner
                }
            }));
            
    
            // Step 2: Upload file to S3
            await fetch(signedUrls[0].uploadUrl, {
                method: "PUT",
                body: files[0],
                headers: { "Content-Type": files[0].type }
            });
    
            setMsg('Upload successful');
            const imageCounts = await fetchImageCounts();

                setData(prevOrders =>
                    prevOrders.map(order => {
                        if (order._id !== orderId) return order;

                        return {
                            ...order,
                            albums: order.albums, // unchanged
                            products: order.products.map((product, idx) => {
                                const key = `${product.productName}-${product.productOptions.size}-${idx}`;
                                return {
                                    ...product,
                                    imageCount: imageCounts?.[order._id]?.products?.[key] ?? 0
                                };
                            })
                        };
                    })
                );
            // Step 3: Update order-specific state
            setUploadedImages((prev) => ({
                ...prev,
                [orderId]: {
                    ...prev[orderId],
                    [productId]: URL.createObjectURL(files[0]),
                },
            }));
    
            setUploadedStatus((prevStatus) => ({
                ...prevStatus,
                [orderId]: {
                    ...prevStatus[orderId],
                    [productId]: true,
                },
            }));
    
            setProductFiles((prev) => ({
                ...prev,
                [orderId]: {
                    ...prev[orderId],
                    [productId]: 1,
                },
            }));
    
            if (checkIfAllImagesUploaded(data[productIndex])) {
                updateOrderStatus(orderId, productIndex, mongoUser.firstName, mongoUser.lastName);
            }
        } catch (error) {
            console.error('❌ Error uploading product image:', error);
            setMsg('Upload failed');
        } finally {
            // ✅ Stop the loading spinner when all images in the order are done
            setUploadingImages((prev) => ({
                ...prev,
                [orderId]: {
                    ...(prev[orderId] || {}),
                    [productId]: false, // ✅ Reset only for this album
                }
            }));
        }
    };

    const imageUploadComplete = (orderId, albums, products) => {
        console.log(`✅ Image upload complete for order: ${orderId}`);
    
        // ✅ Check if all images are uploaded
        const allAlbumsUploaded = albums.every(album => uploadedStatus[orderId]?.[album._id]);
        const allProductsUploaded = products.every(product => uploadedStatus[orderId]?.[product._id]);
    
        if (!allAlbumsUploaded || !allProductsUploaded) {
            alert("Please ensure all images are uploaded before marking as complete.");
            return;
        }
    
        // ✅ Mark order as ready for editing
        setIsReadyForEditing(prev => ({
            ...prev,
            [orderId]: true
        }));
    
        console.log(`🎉 Order ${orderId} is now ready for editing!`);
    
        // ✅ Fire order status update
        updateOrderStatus(orderId);
    };
    
    const fetchImageCounts = async () => {
        try {
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            const mongoUserID = mongoUser._id

            const response = await axios.get(
                `${import.meta.env.VITE_GALLERY_API}/galleries/user/${mongoUserID}/image-count`,
                {
                    headers: {
                        'Authorization': `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            console.log("✅ Image counts fetched:", response.data.imageCounts);
            return response.data.imageCounts; // Object with all counts
        } catch (error) {
            console.error("Error fetching image counts:", error);
            return {};
        }
    };
    

    // Fetch orders on component load
    useEffect(() => {
        if (!mongoUser || !mongoUser._id) {
            console.warn("mongoUser not available, skipping API call.");
            return;
        }
    
        setLoading(true);
    
        const getData = async () => {
            try {
                const session = await fetchAuthSession();
                const idToken = session.tokens?.idToken?.toString();
    
                if (!idToken) {
                    console.error("❌ No ID Token found.");
                    return;
                }
    
                console.log("Fetching orders & image counts for user:", mongoUser._id);
    
                // ✅ Fetch orders & image counts in parallel
                const [ordersResponse, imageCounts] = await Promise.all([
                    axios.get(`${import.meta.env.VITE_ORDERS_API}/orders/${mongoUser._id}`, {
                        headers: { Authorization: `Bearer ${idToken}` },
                    }),
                    fetchImageCounts(),
                ]);
    
                if (!ordersResponse.data || ordersResponse.data.length === 0) {
                    setNoOrders("You don't have any orders yet.");
                    return;
                }
    
                console.log("✅ Image counts fetched:", imageCounts);
    
                // ✅ Merge image counts into orders
                const updatedOrders = ordersResponse.data.map(order => {
                    const updatedAlbums = order.albums.map((album, albumIndex) => {
                        // ✅ Construct the album key based on fetched imageCounts structure
                        const albumKey = `${album.albumName}${album.albumOptions.size}-${album.albumOptions.pages}-${albumIndex}`;
                        const imageCount = imageCounts?.[order._id]?.albums?.[albumKey] ?? 0;
    
                        console.log(`✅ Album Match - Order: ${order._id}, Album: ${album._id}, Key: ${albumKey}, Count: ${imageCount}`);
    
                        return { ...album, imageCount };
                    });
    
                    const updatedProducts = order.products.map((product, productIndex) => {
                        // ✅ Construct the product key based on fetched imageCounts structure
                        const productKey = `${product.productName}-${product.productOptions.size}-${productIndex}`;
                        const imageCount = imageCounts?.[order._id]?.products?.[productKey] ?? 0;
    
                        console.log(`✅ Product Match - Order: ${order._id}, Product: ${product._id}, Key: ${productKey}, Count: ${imageCount}`);
    
                        return { ...product, imageCount };
                    });
    
                    return {
                        ...order,
                        albums: updatedAlbums,
                        products: updatedProducts
                    };
                });
    
                console.log("✅ Final merged orders (Before State Update):", updatedOrders);
    
                setData([...updatedOrders]); // ✅ Ensure state update with a new reference
            } catch (err) {
                console.error("❌ Error fetching orders or image counts:", err);
            } finally {
                setLoading(false);
            }
        };
    
        getData();
    }, [mongoUser]);
     // ✅ Runs when `mongoUser` changes
    
    
    

    useEffect(() => {
        if (!mongoUser) {
            navigate('/login');
            return
        } else {
            const orderIdFromStripe = searchParams.get('orderId');
            if (orderIdFromStripe) {
                setExpand((prevState) => ({ ...prevState, [orderIdFromStripe]: true }));
                setRecentOrderId(orderIdFromStripe);
            }
        }
    }, [mongoUser, navigate, searchParams]);

    useEffect(() => {
        // Only call updateOrderStatus if the imagesCompleted is true and isReadyForEditing is an object with a valid orderId
        if (imagesCompleted && isReadyForEditing && Object.keys(isReadyForEditing).length > 0) {
            const orderId = Object.keys(isReadyForEditing)[0]; // Extract the orderId from isReadyForEditing
            updateOrderStatus(orderId, true);
        }
    }, [isReadyForEditing, imagesCompleted]);
    

    // Render body of page
    return (
        <div>
            <Navbar />
            <h1 style={{ marginTop: '50px' }}>My Orders</h1>
            {loading? <ReactLoading  type='spin' size={55} color='#d4b5a1' />
            :
            
            <div className="orders">
                {loading ? (
                    <ReactLoading type="bubbles" color="#d4b5a1" />
                ) : (Array.isArray(data) && data.length === 0) ? (
                    <p style={{ color: 'royalblue' }}>No order history found</p>
                ) : (
                   Array.isArray(data) && data.map((item, index) => (
                        <div key={index} className="order-box">
                            <h2>Order Details</h2>
                            <div className="order-summary">
                                <div className="order-info">
                                    <p style={{color: '#3c3c3c'}}><span className="label">Order Number: </span>{item._id}</p>
                                    <p style={{color: '#3c3c3c'}}><span className="label">Date Ordered: </span>{new Date(item.createdAt).toDateString()}</p>
                                    <p style={{color: '#3c3c3c'}}><span className="label">Total: </span>{(item.totalPrice / 100).toFixed(2)}</p>
                                    <p style={{color: '#3c3c3c'}}><span className="label">Status: </span>{item.statusHistory?.[item.statusHistory.length - 1]?.status || "Awaiting user images"}</p>
                                </div>
                                <div className="shipping-address">
                                    <p><span className="label">Shipping Address: </span>{item.shippingAddress?.street}, {item.shippingAddress?.city}, {item.shippingAddress?.state} {item.shippingAddress?.zip}</p>
                                </div>
                            </div>
                            <button onClick={() => toggleExpand(item._id)} className="button1" style={{marginLeft: 'auto', marginRight: 'auto'}}>
                                {expand[item._id] ? "Hide Order Items" : "Show Order Items & Upload Images"}
                            </button>
                            {expand[item._id] && (
                                <div className="order-items">
                                    <p style={{color: 'white'}}>Step 1: Upload images for your items.</p>
                                    {/* ALBUMS */}
                                    {Array.isArray(item.albums) && item.albums.length > 0 && (
                                        item.albums.map((album, albumIndex) => {
                                            console.log(`Rendering Album ${albumIndex}:`, album);

                                            return (
                                                <div key={albumIndex} className="item">
                                                    <img src={album.navbarImage} alt={album.albumName} className="item-image" />
                                                    <div className="item-details">
                                                        <p className="item-name" >
                                                            Album: {album.albumName} - {album.albumOptions.size}, {album.albumOptions.pages} Pages
                                                        </p>
                                                        <p className="item-price">
                                                            $ {album.albumOptions.price}
                                                        </p>
                                                        <p style={{ color: 'dodgerblue' }}>
                                                            Images Uploaded: {album.imageCount} / {album.albumOptions.pages * 2}
                                                        </p>
                                                    </div>
                                                    <div className="upload-section">
                                                        {uploadedStatus?.[album._id] ? (
                                                            <>
                                                                <p style={{ color: 'darkorchid', cursor: 'pointer' }} onClick={() => triggerAlbumInput(album._id)}>
                                                                    Add more images (max: {2 * album.albumOptions.pages})
                                                                </p>
                                                                <input
                                                                    type="file"
                                                                    id={`albumFileInput-${album._id}`}
                                                                    accept="image/*"
                                                                    multiple
                                                                    hidden
                                                                    onChange={(e) =>
                                                                        handleAlbumFileChange(item._id,album._id, album.albumName, album.albumOptions.size, album.albumOptions.pages, albumIndex, e)
                                                                    }
                                                                />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <input
                                                                    type="file"
                                                                    id={`albumFileInput-${album._id}`}
                                                                    accept="image/*"
                                                                    multiple
                                                                    hidden
                                                                    onChange={(e) =>
                                                                        handleAlbumFileChange(item._id, album._id, album.albumName, album.albumOptions.size, album.albumOptions.pages, albumIndex, index, e)
                                                                    }
                                                                />
                                                                <button
                                                                    onClick={() => triggerAlbumInput(album._id)}
                                                                    className={`uploadImagesButton button1 ${recentOrderId === item._id ? 'highlight-button' : ''}`}
                                                                >
                                                                   Upload Images "Max: {(album.albumOptions.pages *2)}" {uploadingImages[item._id]?.[album._id] === true && <ReactLoading type="spin" color='white' size={20}/>}

                                                                </button>
                                                                <button onClick={() => openImageModal(item._id, album, "album", albumIndex)} className="viewImageBut">
                                                                    {pictureLoading ? <ReactLoading type="spin" color="dodgerblue" width={20}/> : "View Images"}
                                                                </button>


                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) }



                                    {/* PRODUCTS */}
                                    {Array.isArray(item.products) && item.products?.length > 0 && 
                                        item.products?.map((product, productIndex) => (
                                            <div key={productIndex} className="item">
                                                <img src={product.navbarImage} alt={product.productName} className="item-image" />
                                                <div className="item-details">
                                                    <p className="item-name">Product: {product.productName} - {product.productOptions?.size}</p>
                                                    <p className="item-price">$ {product.productOptions?.price}</p>
                                                    <p style={{ color: 'dodgerblue' }}>
                                                        Images Uploaded: {product.imageCount} / 1
                                                    </p>
                                                </div>
                                                <div className="upload-section">
                                                
                                                    {uploadedStatus[product._id] ? (
                                                        <>
                                                            <p style={{ color: 'darkorchid', cursor: 'pointer' }} onClick={() => triggerProductInput(product._id)}>
                                                                Add more images (max: 1)
                                                            </p>
                                                            <input
                                                                type="file"
                                                                id={`productFileInput-${product._id}`}
                                                                accept="image/*"
                                                                hidden
                                                                onChange={(e) => handleProductFileChange(item._id, product._id, product.productName, product.productOptions.size, productIndex, e)}
                                                                />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <input
                                                                type="file"
                                                                id={`productFileInput-${product._id}`}
                                                                accept="image/*"
                                                                hidden
                                                                onChange={(e) => handleProductFileChange(item._id, product._id, product.productName, product.productOptions.size, productIndex, e)}
                                                                />
                                                            <button onClick={() => triggerProductInput(product._id)} className={`uploadImagesButton button1 ${recentOrderId === item._id ? 'highlight-button' : ''}`}>
                                                                Upload Image {uploadingImages[item._id]?.[product._id] === true && <ReactLoading type="spin" color='white' size={20}/>}

                                                            </button>
                                                            <button onClick={() => openImageModal(item._id, product, "product", productIndex)} className="viewImageBut">
                                                                {pictureLoading ? <ReactLoading type="spin" color="dodgerblue" width={20}/> : "View Images"}
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    }

                                    {/* Complete Image Upload Button */}
                                    <div className="upload-complete" style={{ marginTop: '20px' }}>
                                    <button 
                                        onClick={() => imageUploadComplete(item._id, item.albums, item.products)} 
                                        style={{ backgroundImage: 'linear-gradient(to right, darkblue, darkorchid)' }}
                                    >
                                        {isReadyForEditing[item._id] ? "Upload more images" : "Step 2: Click when complete"}
                                    </button>
                                    {loadingImages[item._id] && (
                                        <ReactLoading color="#d4b5a1" type="spin" width={30} height={30} />
                                    )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
            }
           {isModalOpen && (
            <div className="modal-overlay">
                <div className="modal">
                    <h2>Uploaded Images for {selectedItem?.type === "album" ? "Album" : "Product"}</h2>

                    <div className="image-container">
                        {selectedImages?.map((imgUrl, index) => (
                            <img
                                key={index}
                                src={imgUrl}
                                alt={`Uploaded ${index + 1}`}
                                className={`uploaded-image ${selectedImageIndex === index ? "selected-image" : ""}`}
                                onClick={() => setSelectedImageIndex(index)} // Select image on click
                            />
                        ))}
                    </div>

                    {/* DELETE BUTTON (Only Shows When an Image is Selected) */}
                    {selectedImageIndex !== null && (
                        <button onClick={deleteSelectedImage} className="delete-button">
                            Delete Selected Image
                        </button>
                    )}

                    <button onClick={() => setIsModalOpen(false)} className="close-button">Close</button>
                </div>
            </div>
        )}

            <RequestCallbackButton />
        </div>
    );
}
